/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NotificationStreamsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Subscribe to notification stream via Web Socket
     * Returns an ongoing list of updates (transfers, burns, mints)
     * @returns any OK
     * @throws ApiError
     */
    public subscribeToNotifications({
        network = 'ethereum-mainnet',
    }: {
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/notifications/subscribe',
            path: {
                'network': network,
            },
            errors: {
                400: `Validation Error`,
                403: `Access not enabled`,
            },
        });
    }

}